export const USER_DATA_SET = "USER_DATA_SET";
export const COMPANY_DATA_SET = "COMPANY_DATA_SET";
